export default "__VITE_ASSET__DyzLpMY4__"